import React, { useEffect, useState } from 'react';
import ErrorBoundary from './ErrorBoundary';

// Tab panels that keep their state when you switch away.
//
// Rendering `{active === id && <Panel />}` unmounts the panel, and React throws
// away its state with it — a half-written quote vanishes on a tab switch. So
// once a panel has been opened it stays mounted and is hidden with CSS instead.
//
// Panels are still mounted lazily, on first visit, so opening /admin doesn't
// start every panel's Firestore listener at once.
export default function TabPanels({ active, panels }) {
  const [visited, setVisited] = useState(() => new Set([active]));

  useEffect(() => {
    setVisited((prev) => (prev.has(active) ? prev : new Set(prev).add(active)));
  }, [active]);

  return (
    <>
      {panels.map(({ id, render }) => (
        visited.has(id) ? (
          <div key={id} style={{ display: active === id ? 'block' : 'none' }}>
            {/* Per panel, so one broken panel doesn't take the dashboard with it. */}
            <ErrorBoundary message="This panel failed to load. The rest of the page still works — reloading usually fixes it.">
              {render()}
            </ErrorBoundary>
          </div>
        ) : null
      ))}
    </>
  );
}
